<template>
    <div class="base-login-form flex">
        <h2 class="login-title">
           <slot name="title" />
        </h2>
        <p class="welcome-text">
            <slot name="subtitle" />
        </p>
        <div
            v-if="loginErrorMessage"
            class="form-error"
        >
            {{ loginErrorMessage }}
        </div>
        <form
            id="password-reset"
            novalidate
            @submit.prevent="processForm"
        >
            <fieldset
                :class="{ error: emailErrorMessage || loginErrorMessage }"
            >
                <input
                    id="email"
                    v-model="user.email"
                    type="email"
                    placeholder="Email"
                    name="email"
                    autocomplete="off"
                    :class="{ error: emailErrorMessage || loginErrorMessage }"
                    @click="clearError()"
                >
                <label for="email">
                    Email address
                </label>
            </fieldset>
            <span
                v-if="emailErrorMessage"
                class="form-error"
            >
                {{ emailErrorMessage }}
            </span>
            <fieldset
                :class="{ error: passwordErrorMessage || loginErrorMessage }"
            >
            <input
                id="password"
                v-model="user.password"
                name="password"
                type="password"
                placeholder="Password"
                autocomplete="off"
                :class="{ error: passwordErrorMessage || loginErrorMessage }"
                @click="clearError"
                >
                <label for="password">
                    Password
                </label>
            </fieldset>
            <span
                v-if="passwordErrorMessage"
                class="form-error"
            >
                {{ passwordErrorMessage }}
            </span>
            <fieldset
                :class="{ error: passwordErrorMessage || loginErrorMessage }"
            >
            <input
                id="password-confirmation"
                v-model="user.password_confirmation"
                name="password-confirmation"
                type="password"
                placeholder="Password confirmation"
                autocomplete="off"
                :class="{ error: passwordErrorMessage || loginErrorMessage }"
                @click="clearError"
                >
                <label for="password-confirmation">
                    Password confirmation
                </label>
            </fieldset>
            <span
                v-if="passwordErrorMessage"
                class="form-error"
            >
                {{ passwordErrorMessage }}
            </span>
            <base-form-button
                class="btn"
                :loading="formProcessing || false"
            >
                <slot name="button-label" />
            </base-form-button>
        </form>
        <a
            v-if="! hideLink"
            class="reset-link"
            @click="goToLogin"
        >
            Back to Sign In
        </a>
    </div>
</template>

<script>
import { passwordValidator, emailValidator } from '@/utils/form/validation';
import apiCall from '@/utils/apiCall';
import { loginRedirect } from '@/utils/redirect';

export default {
    props: {
        hideLink: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        user: {
            email: '',
            password: '',
            password_confirmation: '',
        },
        loginErrorMessage: null,
        emailErrorMessage: null,
        passwordErrorMessage: null,
        formProcessing: false,
    }),

    /**
     * Checks if user token and email are present in URL
     */
    beforeCreate() {
        const { token, email } = this.$route.query;

        if (! token || ! email) {
            this.$router.push('/login');
        }
    },

    /**
     * Sets user email
     */
    mounted() {
        this.user.email = this.$route.query.email;
    },

    methods: {
        /**
         * Validates form
         *
         */
        processForm() {
            const { email, password, password_confirmation } = this.user;

            if (! emailValidator(email)) {
                this.emailErrorMessage = 'Please enter valid email adress';
            }

            const passwordValidation = passwordValidator(password, password_confirmation);

            if (! password_confirmation) {
                this.passwordErrorMessage = 'Please enter password confirmation';
            }

            if (! passwordValidation.validation) {
                this.passwordErrorMessage = passwordValidation.message;
            }

            if (this.passwordErrorMessage || this.emailErrorMessage) {
                return;
            }

            this.resetPassword();
        },

        /**
         * Clears errors
         *
         */
        clearError() {
            this.loginErrorMessage = null;
            this.emailErrorMessage = null;
            this.passwordErrorMessage = null;
        },

        /**
         * Call to API for password reset and logins user
         *
         * @returns {void}
         */
        async resetPassword() {
            const params = {
                ...this.user,
                token: this.$route.query.token,
            };

            const { data: { errors, message }, status } = await apiCall(this, 'post', '/api/user/password/reset', params);

            if (200 === status) {
                loginRedirect();
            } else {
                this.loginErrorMessage = errors.length ? errors[errors.length - 1][0] : message;
            }
        },

        /**
         * Redirects to login route
         *
         */
        goToLogin() {
            this.$router.push('/login');
        },
    },
};
</script>
